export class Municipio {
    codigo: number;
    descricao: string;
    uf: string;
    descricaoCompleta: string;
}